















import { computed, defineComponent, ref } from '@vue/composition-api';

const Modal = defineComponent({
  props: {
    image: { type: Array },
  },
  setup(props, { emit }) {
    const internalActive = ref(false);
    const _active = computed(() => internalActive.value);
    const url = ref('');

    function open(string: string) { internalActive.value = true; url.value = string; }
    function close() { internalActive.value = false; url.value = ''; }
    function handleClose() {
      close();
      emit('close');
    }

    return {
      _active,
      url,
      open,
      close,
      handleClose,
    };
  },
});

export default Modal;
